export default {"src":"/_next/static/media/Vector-half-circle.bc361259.svg","height":94,"width":188,"blurWidth":0,"blurHeight":0};